// extracted by mini-css-extract-plugin
export var button = "_ce-0";
export var icon = "_ce-1";